<script setup lang="ts">
/**
 * Left cell for the mobile Finances table (mirrors `ClientMobileLeftCell`'s
 * role/structure). Just the client name plus, when `flagged` is true
 * (negative balance with no visits this period — see `isFlagged` in
 * `FinancesTab`), a danger-colored flag line underneath. No row index: the
 * mobile sketch omits it to save width for the summary column.
 */
import { useI18n } from 'vue-i18n'

withDefaults(
  defineProps<{
    name: string
    flagged?: boolean
  }>(),
  { flagged: false },
)

const { t } = useI18n()
</script>

<template>
  <td class="finance-mobile-left font-tufte text-tufte-text">
    <div class="row-layout">
      <span class="row-name">{{ name }}</span>
      <span v-if="flagged" class="row-flag">{{ t('tabs.finances.noVisitsInPeriod') }}</span>
    </div>
  </td>
</template>

<style scoped>
.finance-mobile-left {
  vertical-align: top;
}

.row-layout {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.row-name {
  font-size: var(--text-tufte-lg);
  line-height: 1.2;
}

.row-flag {
  font-family: var(--font-tufte-sans);
  font-size: var(--text-tufte-xs);
  color: var(--color-money-negative);
  line-height: var(--line-height-tufte-normal);
}
</style>
